// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { PatchMapData, PatchMapDataT } from '../tbs/patch-map-data.js';


export class PatchMapAction implements flatbuffers.IUnpackableObject<PatchMapActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchMapAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchMapAction(bb:flatbuffers.ByteBuffer, obj?:PatchMapAction):PatchMapAction {
  return (obj || new PatchMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchMapAction(bb:flatbuffers.ByteBuffer, obj?:PatchMapAction):PatchMapAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapPatchMap;
}

data(obj?:PatchMapData):PatchMapData|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new PatchMapData()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPatchMapAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapPatchMap);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dataOffset, 0);
}

static endPatchMapAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PatchMapActionT {
  return new PatchMapActionT(
    this.type(),
    (this.data() !== null ? this.data()!.unpack() : null)
  );
}


unpackTo(_o: PatchMapActionT): void {
  _o.type = this.type();
  _o.data = (this.data() !== null ? this.data()!.unpack() : null);
}
}

export class PatchMapActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapPatchMap,
  public data: PatchMapDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = (this.data !== null ? this.data!.pack(builder) : 0);

  PatchMapAction.startPatchMapAction(builder);
  PatchMapAction.addType(builder, this.type);
  PatchMapAction.addData(builder, data);

  return PatchMapAction.endPatchMapAction(builder);
}
}
